module.exports = new __parcel__URL__("guide_wolf_e_dex_text.22218f9f.png").toString();